import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VirtualProgramNode {
  vpName: string;
  vpNameCapitalized: string;
  vpType: string;
}

interface VirtualClassRoomState {
  virtualProgramId: string | null;
  virtualProgramDetails: VirtualProgramNode;
  SelectedSubscriptionTab: number;
}

const initialState: VirtualClassRoomState = {
  virtualProgramId: localStorage.getItem("virtualProgramId") || null,
  virtualProgramDetails: {
    vpName: "",
    vpNameCapitalized: "",
    vpType: "",
  },
  SelectedSubscriptionTab: 0,
};

const virtualClassRoomSlice = createSlice({
  name: "virtualClassRoom",
  initialState,
  reducers: {
    setSelectedVirtualProgramId(
      state,
      action: PayloadAction<{ virtualProgramId:any }>
    ) {
      if (action.payload.virtualProgramId) {
        localStorage.setItem("virtualProgramId", action.payload.virtualProgramId);
        state.virtualProgramId = action.payload.virtualProgramId;
      } else {
        localStorage.removeItem("virtualProgramId");
        state.virtualProgramId = null;
      }
    },
    setVirtualProgramDetails(
      state,
      action: PayloadAction<VirtualProgramNode | undefined>
    ) {
      state.virtualProgramDetails = action.payload || {
        vpName: "",
        vpNameCapitalized: "",
        vpType: ""
      };
    },
    setSelectedSubscriptionTab( 
      state,
      action: PayloadAction<{SelectedSubscriptionTab: number}>
    ){
        state.SelectedSubscriptionTab = action.payload.SelectedSubscriptionTab;
    }
  },
});

export const { setSelectedVirtualProgramId, setVirtualProgramDetails, setSelectedSubscriptionTab } = virtualClassRoomSlice.actions;
export default virtualClassRoomSlice.reducer;
